import React, { useEffect, useState } from 'react'
import TopNavbar from '../topNavbar/TopNavbar';
import Sidebar from '../sidebar/Sidebar';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import Row from 'react-bootstrap/Row';
import '../../assets/css/scss/main.css';
import Col from 'react-bootstrap/Col';
import { Button } from 'react-bootstrap';
import { ChangePasswordApi, UserGetId } from '../../redux/auth-reducer/auth-service';
import { GetToken, GetUser, readApiMessage } from '../../utils/helper/helper';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'
import { Footer } from '../../Footer';
import {
  CONFIRM_PASSWORD_REQUIRED,
  CURRENT_PASSWORD_REQUIRED,
  NEW_PASSWORD_REQUIRED,
  PASSWORD_HINT,
  PASSWORDS_MISMATCH,
  isValidPassword,
  passwordError,
  passwordsDiffer,
} from '../../utils/helper/validation';
import { PasswordToggle } from '../PasswordToggle';

export const ChangePassword = () => {
  const [validated, setValidated] = useState(false);
  const [err, setErr] = useState("");
  const user = JSON.parse(GetUser());
  let [visible, setVisible] = useState(false);
  let [visibleIconPass, setVisibleIconPass] = useState(false);
  let [confVisible, setConfVisible] = useState(false)
  const [userData, setUserData] = useState();
  const navigate = useNavigate();
  const [isValid, setIsValid] = useState(true);
  const [addPassword, setAddPassword] = useState({
    CurrrentPassword: "",
    newpassword: "",
    confirmPassword: "",
  });
  const handelform = (e) => {
    setAddPassword({
      ...addPassword,
      [e.target.name]: e.target.value
    })

  }




  const handelformPass = (e) => {
    setAddPassword({
      ...addPassword,
      newpassword: e.target.value
    })
    setIsValid(isPasswordValid(e.target.value));

  }
  // #274: the shared rule, which ChangePassword.NewPassword's RegularExpression applies too.
  const isPasswordValid = isValidPassword;


  const token = GetToken()

  const handleSubmit = async (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    setValidated(true);
    // #274: nothing is sent while a field is empty or breaks the rule; the server would only
    // refuse it with its own sentence.
    if (form.checkValidity() === false || !isValidPassword(addPassword?.newpassword) || err) {
      event.stopPropagation();
      return;
    }

    const value = {
      "emailId": userData?.emailId,
      "currentPassword": addPassword?.CurrrentPassword,
      "newPassword": addPassword?.newpassword,
      "confirmPassword": addPassword?.confirmPassword

    }
    await ChangePasswordApi(value, token).then((res) => {
      // A refusal is HTTP 200 with status: false, so a body alone is not a success (#44). Compared with
      // true, not truthiness: a validation 400 comes back as a body whose status is the number 400.
      if (res?.status === true) {
        toast.success(readApiMessage(res, "Password changed successfully"));
        navigate(-1);
      } else {
        setAddPassword({
          CurrrentPassword: "",
          newpassword: "",
          confirmPassword: "",
        })
        // undefined means no reply at all, which apiClient.js has already toasted.
        if (res !== undefined) {
          toast.error(readApiMessage(res, "Your password could not be changed. Please try again."));
        }
      }

    });


  };


  useEffect(() => {
    async function UserGet() {
      await UserGetId().then((res) => {
        setUserData(res);

      })
    }
    UserGet();
  }, []);

  const [data, setData] = useState(false);
  function sidebarfun() {
    setData(!data)
  }
  const show = (event) => {
    setVisible(!visible)
  }

  const showConfirm = () => {
    setConfVisible(!confVisible)
  }

  const showIconPass = () => {
    setVisibleIconPass(!visibleIconPass)
  }

  useEffect(() => {
    setErr(passwordsDiffer(addPassword?.newpassword, addPassword?.confirmPassword) ? PASSWORDS_MISMATCH : "")
  }, [addPassword?.newpassword, addPassword?.confirmPassword])
  return (
    <>
      <TopNavbar sidebarfun={sidebarfun} />
      <div className="dasboard-group" >
        <Sidebar data={data} />
        <div className={data ? "dashboard-content full-contnet" : "dashboard-content"}>
          <h1 className="heading-dash">Change Password</h1>
          <div className='ChangePass'>
            {/* #311: Login-form gives the inputs the sign-in page's look; `.ChangePass` in main.scss
                turns its white labels (made for the dark sign-in page) back to the dashboard's text
                colour. Each group has its own controlId, so each label names its input. */}
            <Form noValidate validated={validated} className='Login-form' onSubmit={handleSubmit}>
              <Row className="mb-3">
                <Col className='col-sm-6 offset-md-0'>
                  <Form.Group as={Col} md="12" controlId="change-password-current">
                    <Form.Label>Current password</Form.Label>
                    <InputGroup hasValidation>
                      <Form.Control
                        type={visible ? "text" : "password"}
                        value={addPassword?.CurrrentPassword}
                        onChange={handelform}
                        className='password-input-Change'
                        name="CurrrentPassword"
                        placeholder="Enter current password"
                        aria-describedby="inputGroupPrepend"
                        required
                      />
                      <PasswordToggle visible={visible} onToggle={show} />
                      <Form.Control.Feedback type="invalid">
                        {CURRENT_PASSWORD_REQUIRED}
                      </Form.Control.Feedback>
                    </InputGroup>
                  </Form.Group>
                  <Form.Group as={Col} md="12" controlId="change-password-new">
                    <Form.Label>New password</Form.Label>
                    <InputGroup hasValidation>
                      <Form.Control
                        type={confVisible ? "text" : "password"}
                        onChange={handelformPass}
                        value={addPassword?.newpassword}
                        className='password-input-Change'
                        name="newpassword"
                        placeholder="Enter password"
                        aria-describedby="inputGroupPrepend"
                        isInvalid={!isValid}
                        required
                      />
                      <PasswordToggle visible={confVisible} onToggle={showConfirm} />
                      <Form.Control.Feedback type="invalid">
                        {passwordError(addPassword?.newpassword, NEW_PASSWORD_REQUIRED)}
                      </Form.Control.Feedback>
                      {/* #311: the rules, as on the sign-up pages (#258); the error above replaces
                          them once the password is invalid, or empty on a submit. */}
                      {isValid && !(validated && !addPassword?.newpassword) && (
                        <Form.Text className="form-hint w-100">{PASSWORD_HINT}</Form.Text>
                      )}
                    </InputGroup>
                  </Form.Group>
                  <Form.Group as={Col} md="12" className="text-left" controlId="change-password-confirm">
                    <Form.Label>Confirm password</Form.Label>
                    <InputGroup hasValidation>
                      <Form.Control
                        type={visibleIconPass ? "text" : "password"}
                        name='confirmPassword'
                        className='password-input-Change'
                        autocomplete="on"
                        onChange={handelform}
                        value={addPassword?.confirmPassword}

                        placeholder="Enter confirm password"
                        required
                      />
                      <PasswordToggle visible={visibleIconPass} onToggle={showIconPass} />
                      {
                        err ? <p className='err-message'>{err}</p> : <Form.Control.Feedback type="invalid">
                          {CONFIRM_PASSWORD_REQUIRED}
                        </Form.Control.Feedback>
                      }
                    </InputGroup>
                  </Form.Group>
                  <Col md="12 ">
                    <Button type="submit" className='submit'>Submit</Button>
                  </Col>
                </Col>
              </Row>
            </Form>
          </div>
          <Footer />
        </div>
      </div>
    </>
  )
}
export default ChangePassword;